var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"h5 px-7 text-center btn-link",attrs:{"to":_vm.to,"target":_vm.target}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }